import type { TranslatedString } from '@interfaces/shared';
import { translateBackend } from '../assets/i18n/config';

export type WidgetAdditionalInfoProps = {
  showAdditionalInformation?: boolean;
  additionalInformation?: TranslatedString;
};

export const widgetAdditionalInfo = (
  additionalInfoOpts: WidgetAdditionalInfoProps | undefined | null,
): string | undefined => {
  if (
    additionalInfoOpts?.showAdditionalInformation &&
    additionalInfoOpts.additionalInformation
  ) {
    return translateBackend(additionalInfoOpts.additionalInformation);
  }
  return undefined;
};
